import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { useGroupAttendanceDivisionStore } from "../../../../Store/GroupManagement/GroupsAttendanceDivisionStore";
import { useLoaderStore } from "../../../../Store/Loader/LoaderStore";
import { loadItems } from "../actions";

const customStyles = {
  control: (provided) => ({
    ...provided,
    height: "37px",
    minHeight: "37px",
    width: "100%",
    minWidth: "150px",
    fontSize: "13px",
    fontFamily: "Inter",
    fontWeight: "400",
  }),
};

export default function MonthSelector({ options, property }) {
  const { queryParams, updateParams } = useGroupAttendanceDivisionStore();
  const { setLoader } = useLoaderStore();
  const { t } = useTranslation();

  const handleSelectChange = useCallback(async (e) => {
    setLoader(true);
    if (property === t("Oylar")) {
      let queryString = queryParams;
      if (e?.value == undefined) {
        delete queryString.month;
      } else {
        queryString = { ...queryParams, month: e?.value, page: 1 };
      }
      updateParams(queryString);
      await loadItems(new URLSearchParams(queryString).toString());
    }
    if (property === t("Yillar")) {
      let queryString = queryParams;
      if (e?.value == undefined) {
        delete queryString.year;
      } else {
        queryString = { ...queryParams, year: e?.value, page: 1 };
      }
      updateParams(queryString);
      await loadItems(new URLSearchParams(queryString).toString());
    }
    if (property === t("Filiallar")) {
      let queryString = queryParams;
      if (e?.value == undefined) {
        delete queryString.branch;
      } else {
        queryString = { ...queryParams, branch: e?.value, page: 1 };
      }
      updateParams(queryString);
      await loadItems(new URLSearchParams(queryString).toString());
    }
    setLoader(false);
  });

  return (
    <div className="normal-select-bar">
      <Select
        className="basic-single manage_group_select"
        classNamePrefix="select"
        placeholder={property}
        styles={customStyles}
        options={options}
        isClearable
        onChange={handleSelectChange}
      />
    </div>
  );
}
